const faqs = [
  {
    question: "Can I renew my registration and get stickers on the spot?",
    answer:
      "Yes. We're an authorized Utah On-The-Spot (OTS) station. After your vehicle passes, we renew your registration and give you your stickers and registration card.",
  },
  {
    question: "Do you do VIN inspections?",
    answer:
      "Yes. We verify your VIN and complete Utah Form TC-661 on site, for new residents and out-of-state purchases.",
  },
  {
    question: "Are you state-certified?",
    answer:
      "Yes, for emissions testing, and authorized by the Utah DMV for OTS renewals. Results upload directly to the DMV.",
  },
  {
    question: "Do I need to be there?",
    answer:
      "No. Leave the car accessible and the keys available. No warm-up or other prep needed. The test takes 10–15 minutes.",
  },
  {
    question: "What vehicles can you test?",
    answer:
      "1996 and newer OBD-II cars, trucks, and SUVs. For vintage, diesel, or specialty vehicles, call or text (385) 535-4917 before booking.",
  },
  {
    question: "What areas do you serve?",
    answer:
      "All of Utah County, including Provo, Orem, Lehi, American Fork, Pleasant Grove, Spanish Fork, Springville, and Saratoga Springs. Your vehicle can be registered anywhere in Utah.",
  },
  {
    question: "What if my vehicle fails?",
    answer:
      "You get a printed report with the failure codes. Take it to any mechanic (we only inspect, which keeps testing unbiased), then retest free within 15 days.",
  },
  {
    question: "Do you offer fleet services?",
    answer:
      "Yes. Volume discounts and on-site scheduling across Utah County. Call or text (385) 535-4917.",
  },
];

export default faqs;
